@if (!previewModeFlag && mode !== "supplierEdit") {
  <!-- Excel Import Component -->
  <app-excel-import
    #excelImport
    (importComplete)="onExcelImportComplete($event)"
  ></app-excel-import>

  <!-- Re-import confirmation (mockup slide 13) -->
  @if (showImportConfirm) {
    <div class="ifw-confirm-overlay">
      <div class="ifw-confirm">
        <div class="ifw-confirm-head">
          <span class="ifw-confirm-ic"><i class="fas fa-exclamation-triangle"></i></span>
          <h3>Import a new form?</h3>
        </div>
        <p>You already have a form in progress. Importing a new file will discard any changes in the current Form Builder session. The newly uploaded file will be captured and opened in the Form Builder for you to configure.</p>
        <div class="ifw-confirm-actions">
          <button type="button" class="ifw-c-cancel" (click)="cancelImportConfirm()">Cancel</button>
          <button type="button" class="ifw-c-save" (click)="returnToImport()">Return to Import</button>
        </div>
      </div>
    </div>
  }

  <div style="max-height: 27rem; overflow-y: auto">
    <!-- Import Form Button -->
    <div class="card-header bg-light d-flex justify-content-between align-items-center py-2">
      <div class="d-flex align-items-center">
        @if (importSummary) {
          <i class="fas fa-check-circle text-success me-2"></i>
          <span class="fb-import-summary">Imported <b>"{{ importSummary.fileName }}"</b> &nbsp;—&nbsp; {{ importSummary.sections }} {{ importSummary.sections === 1 ? 'section' : 'sections' }}, {{ importSummary.fields }} {{ importSummary.fields === 1 ? 'field' : 'fields' }} created</span>
        } @else {
          <i class="fas fa-file-import text-success me-2"></i>
          <span class="fw-bold">Quick Import</span>
        }
      </div>
      <div class="d-flex align-items-center gap-3">
        @if (formTitle && !importSummary) {
          <span class="fb-form-name"><i class="fas fa-file-lines"></i> {{ formTitle }}</span>
        }
        <button
          type="button"
          class="btn btn-sm btn-outline-primary"
          (click)="openExcelImport()"
          title="Import form from Excel, Word, or PDF"
        >
          <i class="fas fa-upload me-1"></i>
          Import Form
        </button>
      </div>
    </div>

    @if (apiService?.features?.formExtraction) {
      <div class="card-header">
        <div class="input-group">
          <input
            class="form-control form-control-sm"
            id="uploadFormJSON"
            type="file"
            (change)="onFileChange($event)"
          />
          <span class="input-group-text" id="suffixId">
            <button
              type="button"
              class="btn btn-sm btn-primary"
              (click)="doExtractForm()"
            >
              Extract form
            </button>
          </span>
        </div>
      </div>
    }
    <!-- Form Editor columns -->
    <div
      class="card-body px-1 pt-1 pb-0"
      style="max-height: 26rem; overflow: hidden"
    >
      <div class="row g-1">
        <!-- COLUMN-1: Elements list -->
        <div
          class="col-2 align-self-stretch"
          [ngClass]="isSection ? 'order-3' : 'order-1'"
        >
          <!-- Elements list -->
          <div class="card h-225">
            <div class="card-header" id="headingOne">
              <div>
                <div class="float-left">
                  <i
                    class="cursor-pointer fas fa-circle-info me-2 text-dark"
                    title="Individual elements will assemble to provide a complete
                component for the form’s data and work flow."
                  ></i>
                  <b class="text-dark">Elements List - Test</b>
                </div>
                <br />
              </div>
            </div>
            <div class="card-body p-0" style="height: 15rem; overflow-y: auto">
              <div
                cdkDropList
                #todoList="cdkDropList"
                [cdkDropListData]="originItems_one"
                [cdkDropListConnectedTo]="[doneList]"
              >
                <ul class="exomasterdatalist" style="height: 12rem">
                  @for (item of originItems_one; track item) {
                    @if (item.type?.toLowerCase() != "submitter") {
                      <li
                        class="exomasterdataitem list-item"
                        [ngClass]="
                          isDragablelistDisable
                            ? 'bg-secondary-subtle'
                            : 'bg-body cursor-pointer'
                        "
                        cdkDrag
                        [cdkDragDisabled]="isDragablelistDisable"
                        [cdkDragData]="item"
                      >
                        <div class="d-flex align-items-center">
                          <div>
                            <span class="me-1"
                              ><img
                                src="{{ item.img }}"
                                alt=""
                                [ngClass]="
                                  isDragablelistDisable
                                    ? 'img-greyscale-filter'
                                    : ''
                                "
                            /></span>
                            {{ item.tootipText }}
                          </div>
                          <div class="ms-auto">
                            <i
                              class="fa-solid fa-circle-info fa-lg"
                              [ngClass]="
                                isDragablelistDisable
                                  ? 'text-dark'
                                  : 'text-danger'
                              "
                              placement="left"
                              [ngbTooltip]="item.userHelperContext"
                            ></i>
                          </div>
                        </div>
                      </li>
                    }
                    <!-- SUBMITTER ELEMENT -->
                    @if (
                      !isSection && item.type?.toLowerCase() == "submitter"
                    ) {
                      <li
                        class="exomasterdataitem list-item"
                        [ngClass]="
                          hasSubmitter || isSubmitterdisabled
                            ? 'bg-secondary-subtle'
                            : 'bg-body cursor-pointer'
                        "
                        cdkDrag
                        [cdkDragDisabled]="hasSubmitter || isSubmitterdisabled"
                        [cdkDragData]="item"
                        (cdkDragStarted)="
                          item.type?.toLowerCase() == 'submitter'
                            ? toggleExpand()
                            : ''
                        "
                      >
                        <div class="d-flex align-items-center">
                          <div>
                            <span class="me-1"
                              ><img
                                src="{{ item.img }}"
                                alt=""
                                [ngClass]="
                                  hasSubmitter || isSubmitterdisabled
                                    ? 'img-greyscale-filter'
                                    : ''
                                "
                            /></span>
                            {{ item.tootipText }}
                          </div>
                          <div class="ms-auto">
                            <i
                              class="fa-solid fa-circle-info fa-lg"
                              [ngClass]="
                                hasSubmitter || isSubmitterdisabled
                                  ? 'text-dark'
                                  : 'text-danger'
                              "
                              placement="top"
                              [ngbTooltip]="item.userHelperContext"
                            ></i>
                          </div>
                        </div>
                      </li>
                    }
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- COLUMN-2: Drag & Drop assembly -->
        <div
          class="col-2 align-self-stretch"
          [ngClass]="isSection ? 'order-4' : 'order-2'"
        >
          <div class="card" style="height: 22.5rem">
            <div class="card-header">
              <div class="float-left">
                <i
                  class="cursor-pointer fas fa-circle-info me-2 text-dark"
                  title="Drag your elements and place in this zone to build a complete
                  component to be displayed in the Preview."
                ></i>
                <b class="text-dark">Drag & Drop Assembly</b>
              </div>
              <br />
            </div>
            <div
              class="card-body p-0"
              style="height: 15rem; overflow-y: auto; overflow-x: hidden"
              cdkDropList
              #doneList="cdkDropList"
              (cdkDropListDropped)="
                drop(
                  $event,
                  textContent,
                  radioContent,
                  checkContent,
                  dateContent,
                  dropdownContent,
                  multiselectDropdownContent,
                  textareaContent,
                  textboxContent,
                  guidanceContent,
                  masterdatatextContent,
                  fileContent,
                  submitterContent
                )
              "
            >
              <div>
                @if (!formData.length) {
                  <h6 style="color: grey; text-align: center; padding: 10px">
                    Drag & Drop Here
                  </h6>
                }
                <div>
                  <ul
                    class="list-group"
                    cdkDropList
                    (cdkDropListDropped)="dropzoneContainer($event)"
                  >
                    @for (data of formData; track data; let i = $index) {
                      <div cdkDrag>
                        <li
                          class="list-group-item pointer"
                          style="display: flex; justify-content: space-around"
                        >
                          @if (getImgPathByType(data.type)) {
                            <img
                              title="{{ data.type | titlecase }}"
                              [src]="getImgPathByType(data.type)"
                              class="icon-text"
                              alt=""
                            />
                          }
                          <span>
                            @if (data.type == "text") {
                              <a
                                style="margin-top: 1rem !important"
                                title="Edit"
                                (click)="editComponent(data, textContent, i)"
                              >
                                <i class="fas fa-edit"></i>
                              </a>
                            }
                            @if (data.type == "radio") {
                              <a
                                title="Edit"
                                (click)="editComponent(data, radioContent, i)"
                              >
                                <i class="fas fa-edit"></i>
                              </a>
                            }
                            @if (data.type == "guidance") {
                              <a
                                title="Edit"
                                (click)="
                                  editComponent(data, guidanceContent, i)
                                "
                              >
                                <i class="fas fa-edit"></i>
                              </a>
                            }
                            @if (data.type == "checkbox") {
                              <a
                                title="Edit"
                                (click)="editComponent(data, checkContent, i)"
                              >
                                <i class="fas fa-edit"></i>
                              </a>
                            }
                            @if (data.type == "date") {
                              <a
                                title="Edit"
                                (click)="editComponent(data, dateContent, i)"
                              >
                                <i class="fas fa-edit"></i>
                              </a>
                            }
                            @if (data.type == "dropdown") {
                              <a
                                title="Edit"
                                (click)="
                                  editComponent(data, dropdownContent, i)
                                "
                              >
                                <i class="fas fa-edit"></i>
                              </a>
                            }
                            @if (data.type == "multiselect-dropdown") {
                              <a
                                title="Edit"
                                (click)="
                                  editComponent(
                                    data,
                                    multiselectDropdownContent,
                                    i
                                  )
                                "
                              >
                                <i class="fas fa-edit"></i>
                              </a>
                            }
                            @if (data.type == "textarea") {
                              <a
                                title="Edit"
                                (click)="
                                  editComponent(data, textareaContent, i)
                                "
                              >
                                <i class="fas fa-edit"></i>
                              </a>
                            }
                            @if (data.type == "textbox") {
                              <a
                                title="Edit"
                                (click)="editComponent(data, textboxContent, i)"
                              >
                                <i class="fas fa-edit"></i>
                              </a>
                            }
                            @if (data.type == "Submitter") {
                              <a
                                title="Edit"
                                (click)="
                                  editComponent(data, submitterContent, i)
                                "
                              >
                                <i class="fas fa-edit"></i>
                              </a>
                            }
                          </span>
                          <span>
                            <a (click)="deleteComponent(i)" title="Delete"
                              ><i class="fas fa-trash" style="color: red"></i
                            ></a>
                          </span>
                        </li>
                      </div>
                    }
                  </ul>
                </div>
              </div>
            </div>
            @if (isFormFieldUnsupported) {
              <div class="alert alert-danger mb-0 rounded-0" role="alert">
                <div class="d-flex align-items-stretch">
                  <i class="fa-solid fa-triangle-exclamation text-danger me-1">
                  </i>
                  <small>
                    Field should contain <br />
                    1. Label <br />
                    2. Response option. <br />
                    3. Guidance text (optional) <br />
                    in <strong>the same order</strong>
                  </small>
                </div>
              </div>
            }
            @if (formData.length) {
              <div class="card-footer mt-0">
                <div class="row text-center">
                  @if (addToFormShow && formData.length) {
                    <input
                      type="submit"
                      class="btn btn-primary btn-sm mb-1"
                      [disabled]="isFormFieldUnsupported"
                      [class.btn-disabled]="isFormFieldUnsupported"
                      (click)="hideForm()"
                      value="Add to Forms"
                    />
                  }
                  @if (updateShow && formData.length) {
                    <input
                      type="submit"
                      class="btn btn-primary btn-sm mb-1"
                      [disabled]="isFormFieldUnsupported"
                      [class.btn-disabled]="isFormFieldUnsupported"
                      (click)="hideForm()"
                      value="Update"
                    />
                  }
                  @if (formData.length > 0) {
                    <input
                      type="button"
                      (click)="clearQuesComponents()"
                      class="btn cancelBtn"
                      value="Clear"
                    />
                  }
                </div>
              </div>
            }
          </div>
        </div>
        <!-- COLUMN-3: Individual component preview -->
        <div
          class="align-self-stretch"
          [ngClass]="isSection ? 'col-4 order-5' : 'col-6 order-3'"
        >
          <div class="card" style="height: 22.5rem">
            <div class="card-header">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center justify-content-start">
                  <i
                    class="cursor-pointer fas fa-circle-info me-2 text-dark"
                    title="This is the HTML preview of how your form component will look
                  to the user."
                  ></i>
                  <b class="text-dark">Individual Component Preview</b>
                  <br />
                  <!-- <small class="d-none text-muted mt-1">
              This is the HTML preview of how your form component will look
              to the user.
            </small> -->
                </div>
              </div>
            </div>
            <div
              class="card-body previewcard"
              style="height: 15rem; overflow-y: auto"
            >
              <!-- <div *ngFor="let tagData of formData">
        <div *ngIf="!tagData?.isShortText" [innerHTML]="getSanitizedHtml(tagData.divcontnt)"
        style="margin-bottom: 10px"></div>
      </div> -->
              <div class="row">
                <div
                  [ngClass]="{
                    'col-6': isContainsVerticalAlignment(),
                    'col-12': !isContainsVerticalAlignment(),
                  }"
                >
                  @for (tagData of formData; track tagData; let i = $index) {
                    <div class="row d-block">
                      @if (
                        isRenderQuestion(tagData) &&
                        !isDynamicFieldAppear(tagData.type)
                      ) {
                        <div
                          #preview
                          [innerHTML]="getSanitizedHtml(tagData)"
                          style="margin-bottom: 10px"
                        ></div>
                      }
                      @if (isDynamicFieldAppear(tagData.type)) {
                        <dynamic-field
                          [fieldType]="tagData?.type"
                          [tagData]="tagData"
                          [fieldValue]="tagData?.value"
                          [quesIndex]="i"
                          [alignment]="tagData?.alignment"
                          [isFutureDateAllowed]="tagData?.isFutureDateAllowed"
                          [isBetweenSelected]="tagData?.isBetweenSelected"
                          [minPastMonth]="tagData?.minPastMonth"
                          [maxFutureMonth]="tagData?.maxFutureMonth"
                          (onValueChangeEmit)="onValueChangeEmit($event)"
                        ></dynamic-field>
                      }
                    </div>
                  }
                </div>
                <div
                  [ngClass]="{
                    'col-6': isContainsVerticalAlignment(),
                    'd-none': !isContainsVerticalAlignment(),
                  }"
                >
                  @for (tagData of formData; track tagData) {
                    <div class="row">
                      @if (
                        tagData.alignment && tagData.alignment == "vertical"
                      ) {
                        <div style="float: right" class="col">
                          @if (!tagData?.isShortText) {
                            <div
                              class="mt-3"
                              [innerHTML]="getSanitizedHtml(tagData)"
                            ></div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- COLUMN-4: Sections and sub sections list -->
        @if (isSection) {
          <div
            class="align-self-stretch"
            [ngClass]="isSection ? 'col-2 order-1' : 'd-none'"
          >
            <div class="card" style="height: 22.5rem">
              <div class="card-header">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center justify-content-start">
                    <i
                      class="cursor-pointer fas fa-circle-info me-2 text-dark"
                      title="All sections and their respective subsections"
                    ></i>
                    <b class="text-dark">Sections List</b>
                  </div>
                  <div class="d-flex align-items-center justify-content-end">
                    <i
                      class="cursor-pointer fa-lg fas fa-circle-plus text-dark ms-2"
                      title="Add Section"
                      (click)="addSection(sectionContent)"
                    ></i>
                    @if (!isSaved) {
                      <i
                        class="cursor-pointer fas fa-save ms-4 text-primary"
                        (click)="saveAllSections()"
                      ></i>
                    }
                  </div>
                </div>
              </div>
              <div
                class="card-body p-0"
                style="height: 15rem; overflow-y: auto; overflow-x: hidden"
              >
                @if (sections?.Section?.length) {
                  <ul
                    class="nav flex-column"
                    cdkDropList
                    (cdkDropListDropped)="dropSectionContainer($event)"
                  >
                    @for (
                      section of sections?.Section;
                      track section;
                      let si = $index
                    ) {
                      <li
                        class="nav-item"
                        [ngClass]="
                          activeSection?.UniqueID === section?.UniqueID
                            ? 'bg-primary-custom-subtle'
                            : 'bg-light'
                        "
                        cdkDrag
                      >
                        <div
                          class="d-flex align-items-center justify-content-between p-2 border border-secondary-subtle"
                        >
                          <div
                            class="d-flex align-items-center justify-content-start"
                          >
                            <i
                              class="cursor-pointer fa-solid me-2"
                              [ngClass]="
                                section?.Sections?.length === 0
                                  ? 'fa-2xs fa-grip-vertical'
                                  : expandedSections.includes(section.UniqueID)
                                    ? 'fa-angle-down'
                                    : 'fa-angle-right'
                              "
                              (click)="
                                section?.Sections?.length !== 0 &&
                                expandedSections.includes(section.UniqueID)
                                  ? collapseSubSectionsFor(section, si)
                                  : expandSubSectionsFor(section, si)
                              "
                            ></i>
                            <span
                              class="cursor-pointer"
                              [class.text-primary.fw-bold]="
                                activeSection?.UniqueID === section?.UniqueID
                              "
                              (click)="
                                setSectionDetails(section, si);
                                expandSubSectionsFor(section, si)
                              "
                              >{{ section?.Title | slice: 0 : 10
                              }}{{
                                section?.Title?.length > 10 ? "..." : ""
                              }}</span
                            >
                          </div>
                          <div
                            class="d-flex align-items-center justify-content-end"
                          >
                            @if (section?.Fields?.length === 0) {
                              <i
                                class="cursor-pointer fas fa-circle-plus text-dark ms-2"
                                title="Add Sub-section"
                                [class.cursor-pointer]="activeSection"
                                (click)="
                                  setSectionDetails(section, si);
                                  activeSection
                                    ? addSubSection(subSectionContent)
                                    : ''
                                "
                              ></i>
                            }
                            <i
                              class="ms-2 cursor-pointer fas fa-edit"
                              (click)="
                                setSectionDetails(section, si); editSection(si)
                              "
                              title="Edit"
                            ></i>
                            <i
                              class="ms-2 fas fa-trash"
                              [ngClass]="
                                section?.Sections?.length !== 0
                                  ? 'text-dark'
                                  : 'text-danger cursor-pointer'
                              "
                              (click)="
                                section?.Sections?.length !== 0
                                  ? noop()
                                  : executeSectionDelete(section, si)
                              "
                              [title]="
                                section?.Sections?.length !== 0
                                  ? 'Delete section content first to delete the section'
                                  : 'Delete section'
                              "
                            ></i>
                          </div>
                        </div>
                        <!-- SUB SECTIONS COME HERE -->
                        @if (expandedSections.includes(section.UniqueID)) {
                          <ul
                            class="nav flex-column"
                            cdkDropList
                            (cdkDropListDropped)="
                              dropSubSectionContainer($event)
                            "
                          >
                            @for (
                              subSection of section.Sections;
                              track subSection;
                              let ssi = $index
                            ) {
                              <li
                                class="nav-item p-2 border border-secondary-subtle"
                                [ngClass]="
                                  activeSubSection?.UniqueID ===
                                  subSection?.UniqueID
                                    ? 'bg-primary-subtle'
                                    : 'bg-white'
                                "
                                cdkDrag
                              >
                                @if (
                                  subSection?.ParentID === section.UniqueID
                                ) {
                                  <div
                                    class="d-flex align-items-center justify-content-between"
                                  >
                                    <span
                                      class="cursor-pointer"
                                      [class.text-primary.fw-bold]="
                                        activeSubSection?.UniqueID ===
                                        subSection?.UniqueID
                                      "
                                      (click)="
                                        setSectionDetails(section, si);
                                        setSubSectionDetails(subSection, ssi)
                                      "
                                      >&nbsp;&nbsp;&nbsp;{{
                                        subSection?.Title | slice: 0 : 10
                                      }}{{
                                        subSection?.Title?.length > 10
                                          ? "..."
                                          : ""
                                      }}</span
                                    >
                                    <div
                                      class="d-flex align-items-center justify-content-end"
                                    >
                                      <i
                                        class="ms-2 cursor-pointer fas fa-edit"
                                        (click)="
                                          setSectionDetails(section, si);
                                          setSubSectionDetails(subSection, ssi);
                                          editSubSection(ssi)
                                        "
                                        title="Edit"
                                      ></i>
                                      <i
                                        class="ms-2 cursor-pointer fas fa-trash text-danger"
                                        (click)="
                                          setSectionDetails(section, si);
                                          setSubSectionDetails(subSection, ssi);
                                          deleteSubSection(subSection.UniqueID)
                                        "
                                        title="Delete Sub-section"
                                      ></i>
                                    </div>
                                  </div>
                                }
                              </li>
                            }
                          </ul>
                        }
                      </li>
                    }
                  </ul>
                } @else {
                  <div class="alert alert-info">
                    No sections exist in the Form. Please click on the
                    above&nbsp;<i
                      class="cursor-pointer fa-lg fas fa-circle-plus text-dark"
                      title="Add Section"
                      (click)="addSection(sectionContent)"
                    ></i
                    >&nbsp;icon to add a new section.
                  </div>
                }
              </div>
            </div>
          </div>
        }
        <!-- COLUMN-5: The complete form -->
        <div
          class="col-2 align-self-stretch"
          [ngClass]="isSection ? 'order-2' : 'order-4'"
        >
          <div class="card" style="height: 22.5rem">
            <div class="card-header">
              <div class="float-left">
                <i
                  class="cursor-pointer fas fa-circle-info me-2 text-dark"
                  title="This is the complete inventory and order of your form components
                that a user will see when using the form."
                ></i
                ><b class="text-dark">{{
                  isSection ? "Section fields" : "The Complete Form"
                }}</b>
              </div>
              <br />
              <!-- <small class="d-none float-left text-muted mt-1">
      This is the complete inventory and order of your form components
      that a user will see when using the form.
    </small> -->
            </div>
            <!-- Show only for MULTI SECTION FORM LAYOUT -->
            @if (isSection && sections?.Section?.length) {
              <div
                class="card-body p-0"
                style="height: 15rem; overflow-y: auto"
              >
                <div class="card-body p-0" style="overflow-y: auto">
                  <ul
                    class="list-group p-0 m-0 cursor-move"
                    cdkDropList
                    (cdkDropListDropped)="dropFormContainer($event)"
                  >
                    @if (addformData?.length) {
                      @for (
                        adddata of addformData;
                        track adddata;
                        let j = $index
                      ) {
                        <div cdkDrag>
                          @if (adddata) {
                            @if (
                              adddata?.sectionId ==
                                activeSubSection?.UniqueID ||
                              (adddata?.sectionId == activeSection?.UniqueID &&
                                !activeSubSection?.UniqueID)
                            ) {
                              <li
                                class="list-group-item py-1 pointer"
                                [ngClass]="{
                                  'bg-primary-subtle': isActiveField(adddata),
                                }"
                                style="padding-left: 3px"
                              >
                                <div
                                  class="d-flex align-items-center justify-content-between"
                                >
                                  <div
                                    class="d-flex align-items-center justify-content-start"
                                  >
                                    <i
                                      class="fa-solid fa-2xs fa-grip-vertical mx-2 text-dark"
                                    ></i>
                                    <span
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      [title]="getTitle(adddata)"
                                      [innerHtml]="getQuestionLable(adddata)"
                                      class="pr-1"
                                    ></span>
                                  </div>
                                  <div
                                    class="d-flex align-items-center justify-content-end"
                                  >
                                    <i
                                      class="text-primary fa fa-edit fa-1x cursor-pointer"
                                      title="Edit"
                                      (click)="
                                        !isContainsMasterData(adddata)
                                          ? editquestionComponent(
                                              j,
                                              activeSection,
                                              activeSectionIndex,
                                              false
                                            )
                                          : null
                                      "
                                    ></i>
                                    <i
                                      class="fas fa-clone fa-1x ms-1 cursor-pointer"
                                      (click)="
                                        cloneQuestionComponent(
                                          adddata?.data[0]?.QuestionId,
                                          activeSection,
                                          activeSectionIndex,
                                          false
                                        )
                                      "
                                    ></i>
                                    <i
                                      class="text-danger fa fa-trash fa-1x cursor-pointer ms-4"
                                      title="Delete"
                                      (click)="deletequestionComponent(j)"
                                    ></i>
                                  </div>
                                </div>
                              </li>
                            }
                          }
                        </div>
                      }
                    }
                    @if (fieldsListMsg !== null) {
                      <div class="alert alert-info">
                        {{ fieldsListMsg }}
                      </div>
                    }
                  </ul>
                </div>
              </div>
            }
            <!-- Show only for SINGLE SECTION FORM LAYOUT -->
            @if (!isSection) {
              <div
                class="card-body p-0"
                style="height: 15rem; overflow-y: auto"
                cdkDropList
                (cdkDropListDropped)="dropSectionContainer($event)"
              >
                @for (
                  section of sections.Section;
                  track section;
                  let i = $index
                ) {
                  <div class="card" cdkDrag>
                    @if (isSection) {
                      <div
                        (click)="
                          setSectionDetails(section, i);
                          $event.stopPropagation()
                        "
                        class="list-group-item cursor-move rounded-0 p-1"
                        style="height: 30px"
                        [ngClass]="{
                          'section-bg': currentSectionID != section.UniqueID,
                          'section-active-bg':
                            currentSectionID == section.UniqueID,
                        }"
                      >
                        <div class="float-left fontStyle">
                          {{ section.Title | slice: 0 : 10
                          }}{{ section.Title.length > 10 ? "..." : "" }}
                        </div>
                        <div class="float-right">
                          <span
                            ><i
                              (click)="editSection(i); $event.stopPropagation()"
                              title="Edit"
                              class="fa fa-trash fa-1x me-1 mr-1 pointer fa fa-edit"
                            ></i
                          ></span>
                          <a
                            (click)="
                              deleteSection(section); $event.stopPropagation()
                            "
                            title="Delete"
                            ><i class="fas fa-trash mr-1 me-1 text-danger"></i
                          ></a>
                          <i
                            class="fa fa-trash fa-1x pointer"
                            (click)="
                              ctrlFormContainerAccordian(i);
                              $event.stopPropagation()
                            "
                            [ngClass]="{
                              'fa solid fa-minus': sectionCtrl[i]?.isOpen,
                              'fa-solid fa-add': !sectionCtrl[i]?.isOpen,
                            }"
                            style="padding-right: 5px"
                          >
                          </i>
                        </div>
                      </div>
                    }
                    <div class="card-body p-0" style="overflow-y: auto">
                      @if (
                        (isSection && sectionCtrl[i]?.isOpen) || !isSection
                      ) {
                        <ul
                          class="list-group p-0 m-0 cursor-move"
                          cdkDropList
                          (cdkDropListDropped)="dropFormContainer($event)"
                        >
                          @for (
                            adddata of addformData;
                            track adddata;
                            let j = $index
                          ) {
                            <div cdkDrag>
                              @if (
                                adddata.sectionId == section.UniqueID &&
                                adddata.displayquestion != "Submitter"
                              ) {
                                <li
                                  class="list-group-item py-1 pointer"
                                  style="padding-left: 3px"
                                >
                                  @if (isContainsMasterData(adddata)) {
                                    <img
                                      class="brand-icon mr-1"
                                      src="assets/img/brand.png"
                                      alt=""
                                    />
                                  }
                                  <img src="assets/img/drag-icon.png" />&nbsp;
                                  <span
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    [title]="getTitle(adddata)"
                                    [innerHtml]="getQuestionLable(adddata)"
                                    class="pr-1"
                                  ></span>
                                  <i
                                    class="fa fa-edit fa-1x float-right pointer"
                                    title="Edit"
                                    style="color: blue"
                                    (click)="
                                      !isContainsMasterData(adddata)
                                        ? editquestionComponent(
                                            j,
                                            section,
                                            i,
                                            false
                                          )
                                        : null
                                    "
                                  ></i>
                                  &nbsp;
                                  <i
                                    class="fa fa-trash fa-1x float-right pointer"
                                    title="Delete"
                                    style="color: red"
                                    (click)="deletequestionComponent(j)"
                                  ></i>
                                </li>
                              }
                              @if (
                                adddata.sectionId == section.UniqueID &&
                                adddata.ShowSubmitter &&
                                section.Title == "Submitter"
                              ) {
                                <li
                                  class="list-group-item py-1 pointer"
                                  style="padding-left: 3px"
                                  (click)="
                                    !isContainsMasterData(adddata)
                                      ? editquestionComponent(
                                          j,
                                          section,
                                          i,
                                          true
                                        )
                                      : null
                                  "
                                >
                                  @if (isContainsMasterData(adddata)) {
                                    <img
                                      class="brand-icon mr-1"
                                      src="assets/img/brand.png"
                                      alt=""
                                    />
                                  }
                                  <img src="assets/img/drag-icon.png" />&nbsp;
                                  <span
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    [title]="getTitle(adddata)"
                                    [innerHtml]="getQuestionLable(adddata)"
                                    class="pr-1"
                                  ></span>
                                  <i
                                    class="fa fa-trash fa-1x float-right pointer"
                                    title="Delete"
                                    style="color: red"
                                    (click)="deletSubmitter(adddata.sectionId)"
                                  ></i>
                                </li>
                              }
                            </div>
                          }
                        </ul>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            <!--
  <div
    class="card-footer text-center"
    *ngIf="addformData.length && !fieldsListMsg"
    >
    <div class="row text-center">
      <input
        type="submit"
        class="btn btn-sm btn-primary mb-1"
        (click)="isSection ? onNestedQuesSave() : onQuesSave(false, 1)"
        *ngIf="addformData.length"
        value="Save"
        />
        <input
          type="submit"
          class="btn btn-sm btn-info mb-1"
          (click)="previewQuestionnaire()"
          *ngIf="addformData.length"
          value="Preview"
          />
        </div>
      </div>
      -->
          </div>
        </div>
      </div>
    </div>
    
    <ng-template #guidanceContent let-modal>
      <div class="overflow-auto">
        <form
          #guidanceForm="ngForm"
          (ngSubmit)="onSubmitGuidance(guidanceForm, editIndex)"
        >
          <div class="modal-content" style="overflow-y: auto">
            <div class="modal-body">
              <div>
                <angular-editor
                  [(ngModel)]="guidanceRef.htmlContent"
                  name="name"
                  [config]="config"
                ></angular-editor>
                <div class="row" style="margin-top: 10px">
                  <div class="col-8"></div>
                  <div
                    class="col-4"
                    style="display: flex; justify-content: flex-end"
                  >
                    <input
                      type="submit"
                      class="btn"
                      value="ADD"
                      [disabled]="guidanceRef.htmlContent.length == 0"
                    />&nbsp;&nbsp;
                    <input
                      type="button"
                      value="CANCEL"
                      class="btn cancelBtn"
                      data-dismiss="modal"
                      (click)="modalRemove()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </ng-template>
    <ng-template #submitterContent let-modal>
      <form #fm="ngForm" (ngSubmit)="onSubmitSubmitter(fm, editIndex)">
        <div class="modal-content" style="overflow-y: auto">
          <div class="modal-body">
            <div>
              <div class="row mt-1">
                <div class="col-8">
                  <div class="form-row">
                    <label class="col-sm-2 labelStyle" for="displayText">
                      Field label&nbsp;&nbsp;<i
                        class="fa-solid fa-circle-question px-1"
                        placement="right"
                        ngbTooltip="Provide the title to be rendered against the input field"
                        style="cursor: pointer"
                      ></i>
                    </label>
                    <input
                      type="text"
                      class="col-sm-10 inputStyle"
                      name="displayText"
                      [formControl]="displayText"
                      id="displayText"
                    />
                  </div>
                </div>
              </div>
              <div class="row mt-1 mb-2">
                <div class="col-8">
                  <div class="form-row">
                    <label class="col-sm-2 labelStyle" for="mouseOver">
                      Tooltip text&nbsp;&nbsp;<i
                        class="fa-solid fa-circle-question px-1"
                        placement="right"
                        ngbTooltip="Provide the text that needs to be rendered on mouseover of the field"
                        style="cursor: pointer"
                      ></i>
                    </label>
                    <input
                      type="text"
                      class="inputStyle col-sm-10"
                      name="mouseOver"
                      [formControl]="mouseOverText"
                      id="mouseOver"
                    />
                  </div>
                </div>
              </div>
              @if (!isShortText) {
                <angular-editor
                  id="editor1"
                  [(ngModel)]="guidanceRef.htmlContent"
                  name="name"
                  [config]="config"
                  (keyup)="onKeyup()"
                ></angular-editor>
              }
              <div class="modal-body radioBtn" hidden>
                <div class="labelInline mb-3">
                  <div class="me-1">
                    <label for="inputType" class="form-label"
                      >Format Type</label
                    >
                    <select
                      class="form-select form-select-sm"
                      id="inputType"
                      name="inputType"
                      ngModel
                    >
                      <option value="text">Alphabets</option>
                      <option value="number">Numeric</option>
                      <option value="email">Email</option>
                      <option value="password">Password</option>
                      <option value="tel">Phone</option>
                    </select>
                  </div>
                  <div class="me-1">
                    <label for="minLength" class="form-label">Min length</label>
                    <input
                      type="number"
                      class="form-control"
                      min="-230"
                      max="110"
                      name="minLength"
                      id="minLength"
                      ngModel
                    />
                  </div>
                  <div class="me-1">
                    <label for="maxLength" class="form-label">Max length</label>
                    <input
                      type="number"
                      class="form-control"
                      min="-230"
                      max="110"
                      name="maxLength"
                      id="maxLength"
                      ngModel
                    />
                  </div>
                </div>
              </div>
              <div class="row" style="margin-top: 10px">
                <div class="col-8">
                  <!-- <div class="labelInline"><b>Justify :</b>
                    <label class="labelInline"><input type="radio" name="align" checked value="left" />Horizontal</label>
                    <label class="labelInline"><input type="radio" name="align" value="center" />Vertical</label>
                    <label class="labelInline"><input type="radio" name="align" value="right" />Right</label>
                  </div> -->
                </div>
                <div
                  class="col-4"
                  style="display: flex; justify-content: flex-end"
                >
                  <input
                    type="submit"
                    class="btn"
                    value="ADD"
                    [disabled]="
                      guidanceRef.htmlContent.length == 0 ||
                      displayText.value.length == 0
                    "
                  />&nbsp;&nbsp;
                  <input
                    type="button"
                    value="CANCEL"
                    class="btn cancelBtn"
                    data-dismiss="modal"
                    (click)="modalRemove()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </ng-template>
    <ng-template #textContent let-modal>
      <div class="overflow-auto">
        <form #fm="ngForm" (ngSubmit)="onSubmitText(fm, editIndex)">
          <div class="modal-content">
<div class="modal-body" style="max-height: 600px !important">
              <div class="d-flex  flex-row">
                <div class="col-8">
                  <div class="row mt-1">
                    <div class="form-row">
                      <label class="col-2 labelStyle" for="displayText">
                        Field label&nbsp;&nbsp;<i class="fa-solid fa-circle-question px-1" placement="right"
                          ngbTooltip="Provide the title to be rendered against the input field" style="cursor: pointer"></i>
                      </label>
                      <input type="text" class="col-7 inputFieldStyle" name="displayText" [formControl]="displayText"
                        id="displayText" />
                    </div>
                  </div>
                  <div class="row mt-1 mb-2">
                    <div class="form-row">
                      <label class="col-2 labelStyle" for="mouseOver">
                        Tooltip text&nbsp;&nbsp;<i class="fa-solid fa-circle-question px-1" placement="right"
                          ngbTooltip="Provide the text that needs to be rendered on mouseover of the field"
                          style="cursor: pointer"></i>
                      </label>
                      <input type="text" class="col-7 inputFieldStyle" name="mouseOver" [formControl]="mouseOverText" id="mouseOver" />
                    </div>
                  </div>
                  <div class="row my-2">
                    <div class="form-row">
                      <label class="col-2 labelStyle" for="mouseOver">Field Type&nbsp;&nbsp;<i
                          class="fa-solid fa-circle-question px-1" placement="right"
                          ngbTooltip=" Field type is necessary for identifying the data type of the element."
                          style="cursor: pointer"></i>
                      </label>
                      <div class="col-7">
                        <label class="labelInline"><input type="radio" id="alignment" name="align" value="IndustryData"
                            [formControl]="fieldType" />Industry Data</label>
                        <label class="labelInline"><input type="radio" id="alignment" name="align" value="EnterpriseData"
                            [formControl]="fieldType" />Enterprise Data</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                    <label class="labelAbove" for="placeholderDropdown">
                      <span>Placeholders</span><i class="fa-solid fa-circle-question px-1" placement="right"
                        ngbTooltip="Select a placeholder to insert into the text area" style="cursor: pointer"></i>
                    </label>
                    <div class="d-flex">
                      <select class="form-control mt-2 placeholderDropdown" id="placeholderDropdown" placeholder="Select..."
                        [formControl]="selectedPlaceholder">
                        <option [value]="''">Select a placeholder</option>
                        @for (placeholder of placeholderList; track placeholder) {
                        <option [value]="placeholder.key">{{ placeholder.label }}</option>
                        }
                      </select>
                      <input
                        type="button"
                        [disabled]="!selectedPlaceholder.value"
                        class="btn btn-primary ms-1 addPlaceholder"
                        (click)="addPlaceholder()"
                        value="Add"
                      />
                      <!-- <i class="cursor-pointer fas fa-add ms-4 text-primary addPlaceholder" (click)="addPlaceholder()"></i> -->
                    </div>
                  </div>
              </div>
                @if (!isShortText) {
                <angular-editor #htmlContent [(ngModel)]="guidanceRef.htmlContent" name="name" [config]="config"
                  (keyup)="onKeyup(); onEditorKeyup()" (click)="onEditorClick()"></angular-editor>
                }
                <div class="row" style="margin-top: 10px">
                  <div class="col-8">
                  </div>
                  <div class="col-4" style="display: flex; justify-content: flex-end">
                    <input type="submit" class="btn" value="ADD" [disabled]="
                            guidanceRef.htmlContent.length == 0 ||
                            displayText.value.length == 0
                          " />&nbsp;&nbsp;
                    <input type="button" value="CANCEL" class="btn cancelBtn" data-dismiss="modal"
                      (click)="modalRemove()" />
                  </div>
                </div>
            </div>
          </div>
        </form>
      </div>
    </ng-template>
    <ng-template #radioContent let-modal>
      <div class="overflow-auto">
        <form
          #radioForm="ngForm"
          (ngSubmit)="onSubmitRadio(radioForm, editIndex)"
        >
          <div class="modal-content">
            <div class="modal-header">
              <!-- <div class="fontStyle" style="margin-bottom: 10px; display: contents;">Add Radio button</div> -->
              <div>
                <b style="font-size: 0.95rem">Add Radio button</b><br />
                <small class="text-muted mt-2" style="font-size: 0.75rem">
                  Create a field that allows users to select a single option
                  from a list of options displayed in radio-style format
                </small>
              </div>
            </div>
            <div class="modal-body row">
              <div class="col-6">
                @for (
                  radiodata of radioRef.options;
                  track radiodata;
                  let i = $index
                ) {
                  <div>
                    <span>
                      <i
                        class="fa fa-minus-circle icon-green"
                        aria-hidden="true"
                        (click)="i != 0 ? removeRadioList(i, radiodata.id) : ''"
                      ></i>
                      &nbsp;&nbsp;
                      <input
                        type="text"
                        style="margin-bottom: 10px"
                        placeholder="Option{{ i + 1 }}"
                        [(ngModel)]="radiodata.answer"
                        name="answer{{ i }}"
                      />
                      &nbsp;&nbsp;
                    </span>
                  </div>
                }
                <input
                  type="button"
                  value="Add Option"
                  class="btn"
                  (click)="addRadioList()"
                />
              </div>
              <div class="col-6" style="margin-top: 10px">
                <div class="labelInline">
                  <b>Justify :</b>
                  <label class="labelInline"
                    ><input
                      type="radio"
                      name="align"
                      checked
                      value="left"
                      [(ngModel)]="radioRef.align"
                    />Left</label
                  >
                  <label class="labelInline"
                    ><input
                      type="radio"
                      name="align"
                      value="center"
                      [(ngModel)]="radioRef.align"
                    />Center</label
                  >
                  <label class="labelInline"
                    ><input
                      type="radio"
                      name="align"
                      value="right"
                      [(ngModel)]="radioRef.align"
                    />Right</label
                  >
                </div>
                <small
                  class="d-block text-muted mt-1"
                  style="font-size: 0.75rem"
                >
                  This will be the box placement against the form. This is not
                  the text field justification.
                </small>
                <!-- <div class="labelInline"><b>Align</b>&nbsp;&nbsp;&nbsp;&nbsp;<b>:</b>
                          <label class="labelInline"><input type="radio" name="justify" value="horizontal" />Horizontal</label>
                          <label class="labelInline"><input type="radio" name="justify" value="vertical" />Vertical</label>
                        </div> -->
              </div>
            </div>
            <div class="modal-footer">
              <input
                type="submit"
                [disabled]="
                  radioRef.options.length == 0 || doesContainEmptyRadioOption()
                "
                value="ADD"
                class="btn"
              />
              <input
                type="button"
                value="CANCEL"
                class="btn cancelBtn"
                data-dismiss="modal"
                (click)="modalRemove()"
              />
            </div>
          </div>
        </form>
      </div>
    </ng-template>
    <ng-template #checkContent let-modal>
      <div class="overflow-auto">
        <form
          #checkboxForm="ngForm"
          (ngSubmit)="onSubmitCheck(checkboxForm, editIndex)"
        >
          <div class="modal-content">
            <div class="modal-header">
              <!-- <div class="fontStyle" style="margin-bottom: 10px; display: contents;">Add Checkbox</div> -->
              <div>
                <b style="font-size: 0.95rem">Add Checkbox</b><br />
                <small class="text-muted mt-2" style="font-size: 0.75rem">
                  Create a WYSIWYG text box
                </small>
              </div>
            </div>
            <div class="modal-body row">
              <div class="col-6">
                @for (
                  checkdata of checkboxRef.options;
                  track checkdata;
                  let i = $index
                ) {
                  <div>
                    <span>
                      <i
                        class="fa fa-minus-circle icon-green"
                        aria-hidden="true"
                        (click)="
                          i != 0 ? removeCheckboxList(i, checkdata.id) : ''
                        "
                      ></i>
                      &nbsp;&nbsp;
                      <span>
                        <input
                          type="text"
                          style="margin-bottom: 5px"
                          placeholder="Option{{ i + 1 }}"
                          [(ngModel)]="checkdata.answer"
                          name="answer{{ i }}"
                        />
                        &nbsp;&nbsp; </span
                      ><br />
                    </span>
                  </div>
                }
                <input
                  type="button"
                  value="Add Option"
                  class="btn"
                  (click)="addCheckList()"
                />
              </div>
              <div class="col-6" style="margin-top: 10px">
                <div class="labelInline">
                  <b>Justify :</b>
                  <label class="labelInline"
                    ><input
                      type="radio"
                      name="align"
                      checked
                      value="left"
                      [(ngModel)]="checkboxRef.align"
                    />Left</label
                  >
                  <label class="labelInline"
                    ><input
                      type="radio"
                      name="align"
                      value="center"
                      [(ngModel)]="checkboxRef.align"
                    />Center</label
                  >
                  <label class="labelInline"
                    ><input
                      type="radio"
                      name="align"
                      value="right"
                      [(ngModel)]="checkboxRef.align"
                    />Right</label
                  >
                </div>
                <small
                  class="d-block text-muted mt-1"
                  style="font-size: 0.75rem"
                >
                  This will be the box placement against the form. This is not
                  the text field justification.
                </small>
              </div>
            </div>
            <div class="modal-footer">
              <input
                type="submit"
                [disabled]="
                  checkboxRef.options.length == 0 ||
                  doesContainEmptyCheckboxOption()
                "
                value="ADD"
                class="btn"
              />
              <input
                type="button"
                value="CANCEL"
                class="btn cancelBtn"
                data-dismiss="modal"
                (click)="modalRemove()"
              />
            </div>
          </div>
        </form>
      </div>
    </ng-template>
    <ng-template #dateContent let-modal>
      <div class="overflow-auto">
        <form #dateForm="ngForm" (ngSubmit)="onSubmitDate(dateForm, editIndex)">
          <div class="modal-header">
            <div>
              <b style="font-size: 0.95rem">Add Date</b><br />
              <small class="text-muted mt-2" style="font-size: 0.75rem">
                Create a component that allows users to choose date
              </small>
            </div>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <div
                class="d-flex flex-column align-items-start justify-content-start"
              >
                <div class="form-check">
                  <input
                    class="form-check-input p-0 me-1 mb-1"
                    type="checkbox"
                    id="isBetweenSelected"
                    name="isBetweenSelected"
                    [(ngModel)]="dateRef.isBetweenSelected"
                    style="width: 1rem; height: 1rem"
                  />
                  <label
                    class="form-check-label"
                    for="isBetweenSelected"
                    name="isBetweenSelected"
                    >Select a date Range
                  </label>
                </div>
                @if (dateRef.isBetweenSelected) {
                  <div
                    class="d-flex align-items-start justify-content-start my-2 ms-3"
                  >
                    <div class="me-2">
                      <label for="minPastMonth" class="form-label"
                        ><b>Past</b> months allowed</label
                      >
                      <input
                        style="
                          min-width: 7rem;
                          min-height: 2rem;
                          max-width: 8rem;
                        "
                        type="number"
                        min="0"
                        class="form-control"
                        name="minPastMonth"
                        id="minPastMonth"
                        [(ngModel)]="dateRef.minPastMonth"
                      />
                    </div>
                    <div class="me-2">
                      <label for="maxFutureMonth" class="form-label"
                        ><b>Future</b> months allowed</label
                      >
                      <input
                        style="
                          min-width: 7rem;
                          min-height: 2rem;
                          max-width: 8rem;
                        "
                        type="number"
                        min="0"
                        class="form-control"
                        name="maxFutureMonth"
                        id="maxFutureMonth"
                        [disabled]="!dateRef.isFutureDateAllowed"
                        [(ngModel)]="dateRef.maxFutureMonth"
                      />
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-start justify-content-start ms-3"
                  >
                    <div class="form-check d-flex align-items-center">
                      <input
                        class="form-check-input p-0 me-1 mb-1"
                        type="checkbox"
                        id="isFutureDateAllowed"
                        name="isFutureDateAllowed"
                        [(ngModel)]="dateRef.isFutureDateAllowed"
                        style="width: 1rem; height: 1rem"
                      />
                      <label
                        class="form-check-label"
                        for="isFutureDateAllowed"
                        name="isFutureDateAllowed"
                        >Allow Future Date</label
                      >
                    </div>
                  </div>
                  @if (!dateRef.isFutureDateAllowed) {
                    <div class="alert alert-info mt-2 mx-3">
                      <div class="d-flex align-items-start">
                        <i class="fa fa-solid fa-info-circle m-0 p-0 mt-1"></i
                        >&nbsp;&nbsp;
                        <p class="m-0 p-0">
                          Maximum future date allowed would be the date when
                          supplier starts accessing the form. Check the "allow
                          future date box" to let buyer set a maximum future
                          date for supplier.
                        </p>
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
            <div class="labelInline">
              <b>Justify :</b>
              <label class="labelInline"
                ><input
                  type="radio"
                  name="align"
                  checked
                  value="left"
                  [(ngModel)]="dateRef.align"
                />Left</label
              >
              <label class="labelInline"
                ><input
                  type="radio"
                  name="align"
                  value="center"
                  [(ngModel)]="dateRef.align"
                />Center</label
              >
              <label class="labelInline"
                ><input
                  type="radio"
                  name="align"
                  value="right"
                  [(ngModel)]="dateRef.align"
                />Right</label
              >
            </div>
            <small class="d-block text-muted mt-1" style="font-size: 0.75rem">
              This will be the box placement against the form. This is not the
              text field justification.
            </small>
          </div>
          <div class="modal-footer">
            <input type="submit" value="ADD" class="btn" />
            <input
              type="button"
              class="btn cancelBtn"
              value="CANCEL"
              data-dismiss="modal"
              (click)="modalRemove()"
            />
          </div>
        </form>
      </div>
    </ng-template>
    <ng-template #dropdownContent let-modal>
      <div class="overflow-auto">
        <form
          #dropdownForm="ngForm"
          (ngSubmit)="onSubmitDropdwon(dropdownForm, editIndex)"
        >
          <div class="modal-content">
            <div class="modal-header">
              <!-- <div class="fontStyle" style="margin-bottom: 10px; display: contents;">Add Dropdown</div> -->
              <div>
                <b style="font-size: 0.95rem">Add Dropdown</b><br />
                <small class="text-muted mt-2" style="font-size: 0.75rem">
                  Create a list of values in a dropdown list where users can
                  select one of the values
                </small>
              </div>
            </div>
            <div class="modal-body row">
              <div class="col-6">
                @for (
                  dropdata of dropdownRef.options;
                  track dropdata;
                  let i = $index
                ) {
                  <div>
                    <span>
                      <i
                        class="fa fa-minus-circle icon-green"
                        aria-hidden="true"
                        (click)="
                          i != 0 ? removeDropDownList(i, dropdata.id) : ''
                        "
                      ></i>
                      &nbsp;&nbsp;
                      <input
                        type="text"
                        style="margin-bottom: 10px"
                        placeholder="Option{{ i + 1 }}"
                        [(ngModel)]="dropdata.answer"
                        name="answer{{ i }}"
                      />
                      &nbsp;&nbsp;
                    </span>
                  </div>
                }
                <div class="my-1">
                  <div class="labelInline">
                    <b>Disable input</b>
                    <label class="labelInline"
                      ><input
                        type="checkbox"
                        name="isDisableInputChecked"
                        value="false"
                        [(ngModel)]="dropdownRef.isDisableInputChecked"
                    /></label>
                  </div>
                  <br />
                  <div class="labelInline d-none">
                    <b>Default</b>
                    <label class="labelInline"
                      ><input
                        type="checkbox"
                        name="isDefaultValueChecked"
                        value="false"
                        [(ngModel)]="dropdownRef.isDefaultValueChecked"
                    /></label>
                  </div>
                </div>
                <input
                  type="button"
                  value="Add Option"
                  class="btn"
                  (click)="addDropDownList()"
                />
              </div>
              <div class="col-6" style="margin-top: 10px">
                <div class="labelInline">
                  <b>Justify :</b>
                  <label class="labelInline"
                    ><input
                      type="radio"
                      id="alignment"
                      name="align"
                      checked
                      value="left"
                      [(ngModel)]="dropdownRef.align"
                    />Left</label
                  >
                  <label class="labelInline"
                    ><input
                      type="radio"
                      id="alignment"
                      name="align"
                      value="center"
                      [(ngModel)]="dropdownRef.align"
                    />Center</label
                  >
                  <label class="labelInline"
                    ><input
                      type="radio"
                      id="alignment"
                      name="align"
                      value="right"
                      [(ngModel)]="dropdownRef.align"
                    />Right</label
                  >
                </div>
                <small
                  class="d-block text-muted mt-1"
                  style="font-size: 0.75rem"
                >
                  This will be the box placement against the form. This is not
                  the text field justification.
                </small>
              </div>
            </div>
            <div class="modal-footer">
              <input
                type="submit"
                [disabled]="
                  dropdownRef.options.length == 0 || isContainsEmptyOption()
                "
                value="ADD"
                class="btn"
              />
              <input
                type="button"
                value="CANCEL"
                class="btn cancelBtn"
                data-dismiss="modal"
                (click)="modalRemove()"
              />
            </div>
          </div>
        </form>
      </div>
    </ng-template>
    <ng-template #multiselectDropdownContent let-modal>
      <div class="overflow-auto">
        <form
          #multiSelectDropdownForm="ngForm"
          (ngSubmit)="
            onSubmitMultiselectDropdwon(multiSelectDropdownForm, editIndex)
          "
        >
          <div class="modal-content">
            <div class="modal-header">
              <div>
                <b style="font-size: 0.95rem">Add Multiselect Dropdown</b><br />
                <small class="text-muted mt-2" style="font-size: 0.75rem">
                  Create a list of values in a dropdown list where users can
                  select multiple values
                </small>
              </div>
            </div>
            <div class="modal-body row">
              <div class="col-6">
                @for (
                  dropdata of multiSelectDropdownRef.options;
                  track dropdata;
                  let i = $index
                ) {
                  <div>
                    <span>
                      <i
                        class="fa fa-minus-circle icon-green"
                        aria-hidden="true"
                        (click)="
                          i != 0
                            ? removeMultiselectDropDownList(i, dropdata.id)
                            : ''
                        "
                      ></i>
                      &nbsp;&nbsp;
                      <input
                        type="text"
                        style="margin-bottom: 10px"
                        placeholder="Option{{ i + 1 }}"
                        [(ngModel)]="dropdata.answer"
                        name="answer{{ i }}"
                      />
                      &nbsp;&nbsp;
                    </span>
                  </div>
                }
                <input
                  type="button"
                  value="Add Option"
                  class="btn"
                  (click)="addMultiselectDropDownList()"
                />
              </div>
              <div class="col-6" style="margin-top: 10px">
                <div class="labelInline">
                  <b>Justify :</b>
                  <label class="labelInline"
                    ><input
                      type="radio"
                      id="alignment"
                      name="align"
                      checked
                      value="left"
                      [(ngModel)]="multiSelectDropdownRef.align"
                    />Left</label
                  >
                  <label class="labelInline"
                    ><input
                      type="radio"
                      id="alignment"
                      name="align"
                      value="center"
                      [(ngModel)]="multiSelectDropdownRef.align"
                    />Center</label
                  >
                  <label class="labelInline"
                    ><input
                      type="radio"
                      id="alignment"
                      name="align"
                      value="right"
                      [(ngModel)]="multiSelectDropdownRef.align"
                    />Right</label
                  >
                </div>
                <small
                  class="d-block text-muted mt-1"
                  style="font-size: 0.75rem"
                >
                  This will be the box placement against the form. This is not
                  the text field justification.
                </small>
              </div>
            </div>
            <div class="modal-footer">
              <input
                type="submit"
                [disabled]="
                  multiSelectDropdownRef.options.length == 0 ||
                  doesContainEmptyOption()
                "
                value="ADD"
                class="btn"
              />
              <input
                type="button"
                value="CANCEL"
                class="btn cancelBtn"
                data-dismiss="modal"
                (click)="modalRemove()"
              />
            </div>
          </div>
        </form>
      </div>
    </ng-template>
    <ng-template #textareaContent let-modal>
      <div class="overflow-auto">
        <form
          #textareaForm="ngForm"
          (ngSubmit)="onSubmitTextArea(textareaForm, editIndex)"
        >
          <div class="modal-content">
            <div class="modal-header">
              <!-- <div class="fontStyle" style="margin-bottom: 10px; display: contents;">Add Textarea</div> -->
              <div>
                <b style="font-size: 0.95rem">Add Textarea</b><br />
                <small class="text-muted mt-2" style="font-size: 0.75rem">
                  Create a multi-line input field that allows for longer text
                  input
                </small>
              </div>
            </div>
            <div
              class="modal-body radioBtn"
              style="max-height: 100% !important"
            >
              <div class="labelInline">
                <b>Justify :</b>
                <label class="labelInline"
                  ><input
                    type="radio"
                    name="align"
                    checked
                    value="left"
                    [(ngModel)]="textareaRef.align"
                  />Left</label
                >
                <label class="labelInline"
                  ><input
                    type="radio"
                    name="align"
                    value="center"
                    [(ngModel)]="textareaRef.align"
                  />Center</label
                >
                <label class="labelInline"
                  ><input
                    type="radio"
                    name="align"
                    value="right"
                    [(ngModel)]="textareaRef.align"
                  />Right</label
                >
              </div>
              <div class="labelInline">
                <b>Hidden : </b>
                <label class="labelInline"
                  ><input
                    type="checkbox"
                    name="isHidden"
                    value="false"
                    [(ngModel)]="textareaRef.isHidden"
                /></label>
              </div>
              <small class="d-block text-muted mt-1" style="font-size: 0.75rem">
                This will be the box placement against the form. This is not the
                text field justification.
              </small>
            </div>
            <div class="modal-footer">
              <input type="submit" value="ADD" class="btn" />
              <input
                type="button"
                value="CANCEL"
                class="btn cancelBtn"
                data-dismiss="modal"
                (click)="modalRemove()"
              />
            </div>
          </div>
        </form>
      </div>
    </ng-template>
    <ng-template #fileContent let-modal>
      <div class="overflow-auto">
        <form #fm="ngForm" (ngSubmit)="onSubmitFile(fm, editIndex)">
          <div class="modal-content">
            <div class="modal-header">
              <!-- <div class="fontStyle" style="margin-bottom: 10px; display: contents;">Add Attachment</div> -->
              <div>
                <b style="font-size: 0.95rem">Add attachment</b><br />
                <small class="text-muted mt-2" style="font-size: 0.75rem">
                  Create a component that allows users to attach files to a form
                </small>
              </div>
            </div>
            <div>
              <div class="modal-body">
                <div class="col-6" style="margin-top: 10px">
                  <div class="labelInline">
                    <b>Justify :</b>
                    <label class="labelInline"
                      ><input
                        type="radio"
                        id="alignment"
                        name="align"
                        checked
                        value="left"
                        [ngModel]="defaultAlignment"
                      />Left</label
                    >
                    <label class="labelInline"
                      ><input
                        type="radio"
                        id="alignment"
                        name="align"
                        value="center"
                        [ngModel]="defaultAlignment"
                      />Center</label
                    >
                    <label class="labelInline"
                      ><input
                        type="radio"
                        id="alignment"
                        name="align"
                        value="right"
                        [ngModel]="defaultAlignment"
                      />Right</label
                    >
                  </div>
                  <small
                    class="d-block text-muted mt-1"
                    style="font-size: 0.75rem"
                  >
                    This will be the box placement against the form. This is not
                    the text field justification.
                  </small>
                  <div class="row mt-3">
                    <div class="col">
                      <b>Note:</b> Upload file accepts pdf,word and excel
                      formats, limit upto 5mb.
                    </div>
                  </div>
                </div>
                <!-- <div class="row">
                                                                                                            <div class="col">
                                                                                                              <div class="input-group mb-3">
                                                                                                                <div class="custom-file">
                                                                                                                  <input type="file" class="custom-file-input" id="file" #fileUpload (click)="clearFile()"
                                                                                                                    (change)="handleFileInput($event,editIndex)">
                                                                                                                    <label class="custom-file-label" for="inputGroupFile02"
                                                                                                                      aria-describedby="inputGroupFileAddon02">{{fileToUpload ? fileToUpload.name : 'Choose
                                                                                                                    file'}}</label>
                                                                                                                  </div>
                                                                                                                  <div class="input-group-append">
                                                                                                                    <span class="input-group-text" id="inputGroupFileAddon02"
                                                                                                                    (click)="onSubmitFile(fm, editIndex)">Upload</span>
                                                                                                                  </div>
                                                                                                                </div>
                                                                                                              </div>
                                                                                                            </div> -->
              </div>
              <div class="modal-footer">
                <div class="float-right">
                  <input
                    type="submit"
                    value="Add"
                    class="btn btn-primary"
                  />&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    (click)="modalRemove()"
                  >
                    Cancel
                  </button>
                </div>
                <br />
              </div>
            </div>
          </div>
        </form>
      </div>
    </ng-template>
    <ng-template #textboxContent let-modal>
      <div class="overflow-auto">
        <form
          #textboxForm="ngForm"
          (ngSubmit)="onSubmitTextbox(textboxForm, editIndex)"
        >
          <div class="modal-content">
            <div class="modal-header">
              <!-- <div class="fontStyle" style="margin-bottom: 10px; display: contents;">Add Textbox</div> -->
              <div>
                <b style="font-size: 0.95rem">Add Textbox</b><br />
                <small class="text-muted mt-2" style="font-size: 0.75rem">
                  Box placement of of the texbox.
                </small>
              </div>
            </div>
            <div class="modal-body radioBtn">
              @if (
                (
                  [
                    textboxRef.formatType,
                    textboxRef.minLength,
                    textboxRef.maxLength,
                  ] | inputBoxValidationPipe: "alert"
                ).alertMsgHtml.content
              ) {
                <div
                  class="alert alert-primary mb-4"
                  role="alert"
                  [innerHTML]="
                    (
                      [
                        textboxRef.formatType,
                        textboxRef.minLength,
                        textboxRef.maxLength,
                      ] | inputBoxValidationPipe: 'alert'
                    ).alertMsgHtml.content
                  "
                  class="
              alert-{{
                    (
                      [
                        textboxRef.formatType,
                        textboxRef.minLength,
                        textboxRef.maxLength,
                      ] | inputBoxValidationPipe: 'alert'
                    ).alertMsgHtml.color
                  }}"
                ></div>
              }
              <div class="labelInline mb-3">
                <div class="me-1">
                  <label for="inputType" class="form-label">Format Type</label>
                  <select
                    class="form-select form-select-sm"
                    id="inputType"
                    name="inputType"
                    [(ngModel)]="textboxRef.formatType"
                    [value]="textboxRef.formatType || 'text'"
                  >
                    <option value="text">AlphaNumeric</option>
                    <!-- <option value="number">Number (0 to 999)</option> -->
                    <option value="number2">Number</option>
                    <option value="email">Email</option>
                    <option value="password">Password</option>
                    <option value="tel">Phone</option>
                    <option value="dunsNumber">DUNS Numbers</option>
                    <option value="naics">NAICS</option>
                    <option value="cageCode">CAGE code</option>
                  </select>
                </div>
                <div class="me-1">
                  <div>
                    @switch (textboxRef.formatType) {
                      <!-- <div *ngSwitchCase="'number'">
                                                                                                                    <label for="minLength" class="form-label"><b>Minimum</b> limit</label>
                                                                                                                    <input type="number"  class="form-control" value="0" name="minLength" id="minLength"  [(ngModel)]="textboxRef.minLength"/>
                                                                                                                    <small
                                                                                                                      id="legalMinHelpId"
                                                                                                                      class="form-text text-danger"
                      [innerHTML]="
                        (
                          [textboxRef.formatType, textboxRef.minLength, textboxRef.maxLength]
                          | inputBoxValidationPipe : 'legal_min'
                        ).validationMsgHtml.minField
                      "
                                                                                                                    ></small>
                                                                                                                  </div> -->
                      @case ("number2") {
                        <div>
                          <label for="minLength" class="form-label"
                            ><b>Minimum</b> limit</label
                          >
                          <input
                            type="number"
                            class="form-control"
                            value="-999"
                            name="minLength"
                            id="minLength"
                            [(ngModel)]="textboxRef.minLength"
                          />
                          <small
                            id="legalMinHelpId"
                            class="form-text text-danger"
                            [innerHTML]="
                              (
                                [
                                  textboxRef.formatType,
                                  textboxRef.minLength,
                                  textboxRef.maxLength,
                                ] | inputBoxValidationPipe: 'legal_min'
                              ).validationMsgHtml.minField
                            "
                          ></small>
                        </div>
                      }
                      @default {
                        <div></div>
                      }
                    }
                  </div>
                </div>
                <div class="me-1">
                  <div>
                    @switch (textboxRef.formatType) {
                      @case ("number2") {
                        <div>
                          <label for="maxLength" class="form-label"
                            ><b>Maximum</b> limit</label
                          >
                          <input
                            type="number"
                            class="form-control"
                            value="999"
                            name="maxLength"
                            id="maxLength"
                            [(ngModel)]="textboxRef.maxLength"
                          />
                          <small
                            id="legalMaxHelpId"
                            class="form-text text-danger"
                            [innerHTML]="
                              (
                                [
                                  textboxRef.formatType,
                                  textboxRef.minLength,
                                  textboxRef.maxLength,
                                ] | inputBoxValidationPipe: 'legal_max'
                              ).validationMsgHtml.maxField
                            "
                          ></small>
                        </div>
                      }
                      @default {
                        <div></div>
                      }
                    }
                  </div>
                </div>
              </div>
              <div class="labelInline">
                <b>Justify :</b>
                <label class="labelInline"
                  ><input
                    type="radio"
                    name="align"
                    checked
                    value="left"
                    [(ngModel)]="textboxRef.align"
                  />Left</label
                >
                <label class="labelInline"
                  ><input
                    type="radio"
                    name="align"
                    value="center"
                    [(ngModel)]="textboxRef.align"
                  />Center</label
                >
                <label class="labelInline"
                  ><input
                    type="radio"
                    name="align"
                    value="right"
                    [(ngModel)]="textboxRef.align"
                  />Right</label
                >
              </div>
              <small class="d-block text-muted mt-1" style="font-size: 0.75rem">
                This will be the box placement against the form. This is not the
                text field justification.
              </small>
            </div>
            <div class="modal-footer">
              <input type="submit" value="ADD" class="btn" />
              <input
                type="button"
                class="btn cancelBtn"
                value="CANCEL"
                data-dismiss="modal"
                (click)="modalRemove()"
              />
            </div>
          </div>
        </form>
      </div>
    </ng-template>
    <ng-template #masterdatatextContent let-modal></ng-template>
    <ng-template #modalPreviewContent let-modal>
      <div class="modal-content overflow-auto">
        <div class="modal-header mdl-header-bg">
          <div>Form Review</div>
          <button
            type="button"
            class="btn btn-success"
            class="close"
            (click)="modalRemove()"
          >
            &times;
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              @for (
                adddata of this.addformData;
                track adddata;
                let j = $index
              ) {
                <div>
                  <!-- {{adddata.displayquestion}} -->
                  <div class="card shadow border-dark">
                    <div class="card-body">
                      @for (ques of adddata.data; track ques; let k = $index) {
                        <div class="d-block">
                          <div
                            [innerHtml]="
                              ques.question
                                .changingThisBreaksApplicationSecurity
                                | safeHtml
                                | evalScript
                            "
                          ></div>
                        </div>
                      }
                    </div>
                  </div>
                  <!-- <hr /> -->
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #previewQuestionnaireContent let-modal>
      <div class="d-flex flex-column" style="height: 100vh">
        <app-header class="flex-shrink-0"></app-header>
        <div class="modal-content overflow-auto flex-grow-1">
          <div class="modal-header">
            <div style="font-size: 24px">Preview: {{ FormName }}</div>
            <button
              type="button"
              class="btn-close"
              aria-label="Close preview"
              (click)="modalRemove()"
            >
            </button>
          </div>

          <div class="modal-body overflow-hidden">
            <app-buyer-preview
              [renderPreviewData]="addformData"
            ></app-buyer-preview>
          </div>
        <div
          class="modal-footer d-flex align-items-center justify-content-between"
        >
          <ng-container>
            <!-- LABELS -->
            <div
              class="d-flex align-items-center justify-content-start me-auto"
            >
              <div class="d-flex flex-column">
                @for (label of buyerPreviewService.labels; track label) {
                  <div
                    class="d-flex flex-row align-items-center justify-content-start"
                  >
                    <i [class]="label.faIconClass"></i>&nbsp;&nbsp;
                    <span class="">{{ label.infoText }}</span>
                  </div>
                }
              </div>
            </div>
            <!-- INFO -->
            @if (
              buyerPreviewService.isLastNonSubmitterQnPreview &&
              !buyerPreviewService.renderSubmitterPreview
            ) {
              <span class="text-primary my-2">
                <i class="fa fa-info-circle"></i>&nbsp; Please use the left
                navigation panel to continue to fill submitter details.
              </span>
            }
            <!-- BUTTONS -->
            @if (
              buyerPreviewService.isViewReady &&
              buyerPreviewService.enableNavigation &&
              !buyerPreviewService.isMgmtPreview
            ) {
              <div
                class="d-flex align-items-center justify-content-end ms-auto"
              >
                @if (buyerPreviewService.renderSubmitterPreview && formType != "None") {
                  <!-- GET SCORES BUTTON -->
                  <button
                    type="button"
                    class="btn btn-primary ms-2"
                    (click)="buyerPreviewService.execute('getScores')"
                  >
                    Get scores
                  </button>
                }
                @if (!buyerPreviewService.renderSubmitterPreview) {
                  <div
                    class="d-flex flex-column align-items-end justify-content-end"
                  >
                    <!-- PREV NEXT NAVIGATION BUTTONS -->
                    <div
                      class="d-flex flex-row align-items-center justify-content-end"
                    >
                      <button
                        type="button"
                        class="btn btn-primary ms-2"
                        (click)="
                          buyerPreviewService.execute('goToPreviousNode')
                        "
                        [disabled]="buyerPreviewService.disablePreviousButton"
                      >
                        Previous
                      </button>
                      @if (!buyerPreviewService.isLastNonSubmitterQnPreview) {
                        <button
                          type="button"
                          class="btn btn-primary ms-2"
                          (click)="buyerPreviewService.execute('goToNextNode')"
                          [disabled]="buyerPreviewService.disableNextButton"
                        >
                          Next
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </ng-container>
        </div>
      </div>
      </div>
    </ng-template>
    <ng-template #sectionContent let-modal>
      <div class="overflow-auto">
        <form
          #sectionFormRef="ngForm"
          (ngSubmit)="onSubmitSection(sectionFormRef, sectionEditIndex)"
        >
          <div class="modal-content">
            <div class="modal-header">
              <span class="fw-bold"
                >{{
                  sectionEditIndex !== null ? "Edit" : "Create"
                }}
                Section</span
              >
            </div>
            <div class="modal-body" style="max-height: 600px !important">
              <div>
                <div class="row" style="margin-top: 5px">
                  <div class="col-12">
                    <div class="form-row">
                      <label
                        class="col-sm-3 labelStyle"
                        for="Title"
                        style="text-align: right"
                      >
                        Title<span style="color: red"><sup>*</sup></span
                        >:
                      </label>
                      <input
                        type="text"
                        class="col-sm-8 inputStyle"
                        name="Title"
                        [formControl]="sectionTitle"
                        id="Title"
                      />
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 5px">
                  <div class="col-12">
                    <div class="form-row">
                      <label
                        class="col-sm-3 labelStyle"
                        for="Description"
                        style="text-align: right"
                      >
                        Description:
                      </label>
                      <input
                        type="text"
                        class="inputStyle col-sm-8"
                        name="Description"
                        [formControl]="sectionDescription"
                        id="Description"
                      />
                    </div>
                  </div>
                </div>
                <!--
                <div class="row" style="margin-top: 5px">
                  <div class="col-12">
                    <div class="form-row">
                      <label
                        class="col-sm-3 labelStyle"
                        for="Title"
                        style="text-align: right"
                      >
                        Content Type:<span style="color: red"
                          ><sup>*</sup></span
                        >:
                      </label>
                      <div class="mt-3">
                        <label class="labelInline"
                          ><input
                            type="radio"
                            name="sectionContentType"
                            checked
                            value="onlyFields"
                            [formControl]="sectionContentType"
                          />Fields</label
                        >
                        <label class="labelInline"
                          ><input
                            type="radio"
                            name="sectionContentType"
                            value="onlySubSections"
                            [formControl]="sectionContentType"
                          />Sub-sections</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                -->
                <div class="row" style="margin-top: 5px">
                  <div class="col-12">
                    <div class="form-row">
                      <label
                        class="col-sm-3 labelStyle"
                        for="Title"
                        style="text-align: right"
                      >
                        Display Type:<span style="color: red"><sup>*</sup></span
                        >:
                      </label>
                      <div class="mt-3">
                        <label class="labelInline"
                          ><input
                            type="radio"
                            name="sectionDisplayType"
                            id="oneQuestionDisplay"
                            value="One"
                            checked
                            [formControl]="sectionDisplayType"
                          />One Question Display</label
                        >
                        <label class="labelInline"
                          ><input
                            type="radio"
                            name="sectionDisplayType"
                            id="allSectionQuestionsDisplay"
                            value="All"
                            [formControl]="sectionDisplayType"
                          />All Section Questions Display</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 10px">
                  <div class="col-8"></div>
                  <div
                    class="col-4"
                    style="display: flex; justify-content: flex-end"
                  >
                    <input
                      [disabled]="sectionTitle.value.length == 0"
                      type="submit"
                      class="btn"
                      [value]="sectionEditIndex !== null ? 'Update' : 'Add'"
                    />&nbsp;&nbsp;
                    <input
                      type="button"
                      value="Cancel"
                      class="btn cancelBtn"
                      data-dismiss="modal"
                      (click)="modalRemove()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </ng-template>
    <ng-template #subSectionContent let-modal>
      <div class="overflow-auto">
        <form
          #subSectionFormRef="ngForm"
          (ngSubmit)="
            onSubmitSubSection(subSectionFormRef, subSectionEditIndex)
          "
        >
          <div class="modal-content">
            <div class="modal-header">
              <span class="fw-bold"
                >{{
                  subSectionEditIndex !== null ? "Edit" : "Create"
                }}
                Sub-section</span
              >
            </div>
            <div class="modal-body" style="max-height: 600px !important">
              <div>
                <div class="row" style="margin-top: 5px">
                  <div class="col-12">
                    <div class="form-row">
                      <label
                        class="col-sm-3 labelStyle"
                        for="Title"
                        style="text-align: right"
                      >
                        Title<span style="color: red"><sup>*</sup></span
                        >:
                      </label>
                      <input
                        type="text"
                        class="col-sm-8 inputStyle"
                        name="Title"
                        [formControl]="subSectionTitle"
                        id="Title"
                      />
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 5px">
                  <div class="col-12">
                    <div class="form-row">
                      <label
                        class="col-sm-3 labelStyle"
                        for="Description"
                        style="text-align: right"
                      >
                        Description:
                      </label>
                      <input
                        type="text"
                        class="inputStyle col-sm-8"
                        name="Description"
                        [formControl]="subSectionDescription"
                        id="Description"
                      />
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 10px">
                  <div class="col-8"></div>
                  <div
                    class="col-4"
                    style="display: flex; justify-content: flex-end"
                  >
                    <input
                      [disabled]="subSectionTitle?.value?.length == 0"
                      type="submit"
                      class="btn"
                      [value]="subSectionEditIndex !== null ? 'Update' : 'Add'"
                    />&nbsp;&nbsp;
                    <input
                      type="button"
                      value="Cancel"
                      class="btn cancelBtn"
                      data-dismiss="modal"
                      (click)="modalRemove()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </ng-template>
  </div>

  <!-- Footer buttons - outside scroll container so always visible -->
  <div class="card-footer bg-transparent">
    <div class="d-flex align-items-center justify-content-end">
      @if (addformData.length) {
        <input
          type="submit"
          class="btn btn-sm btn-primary ms-1"
          (click)="isSection ? onNestedQuesSave() : onQuesSave(false, 1)"
          value="Save"
        />
        <input
          type="submit"
          class="btn btn-sm btn-info ms-1"
          (click)="previewQuestionnaire()"
          value="Preview"
        />
      }
    </div>
  </div>
}

<!-- JSON Debug -->
<div class="d-none row">
  <div class="col">
    <pre>{{ sections | json }}</pre>
  </div>
  <div class="col">
    <pre>{{ addformData | json }}</pre>
  </div>
</div>

<!-- Management preview -->
@if (
  !isSection &&
  (previewModeFlag || mode === "supplierEdit") &&
  addformData.length
) {
  <app-buyer-preview
    [renderPreviewData]="addformData"
    [isMgmtPreview]="true"
    [previewModeFlag]="true"
    [mode]="mode"
  ></app-buyer-preview>
}

<!-- Multi section form preview -->
<ng-template #multiSectionQuestionnairePreview let-modal>
  <div class="d-flex flex-column" style="height: 100vh">
    <app-header class="flex-shrink-0"></app-header>
    <div class="modal-header flex-shrink-0">
      <span class="modal-title" style="font-size: 24px">Preview: {{ FormName }}</span>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modalRemove()"
      ></button>
    </div>
    <div class="modal-body p-0 overflow-auto flex-grow-1">
      <app-multi-section-form-preview
        [allFieldsList]="addformData"
        [allSectionsList]="sections.Section"
        (modalClose)="modal.close($event)"
        (modalDismiss)="modal.dismiss($event)"
        [isBuyerManagementPreview]="previewModeFlag"
        [mode]="mode"
      />
    </div>
  </div>
</ng-template>
@if (
  isSection &&
  (previewModeFlag || mode === "supplierEdit") &&
  addformData.length
) {
  <app-multi-section-form-preview
    [allFieldsList]="addformData"
    [allSectionsList]="sections.Section"
    [isBuyerManagementPreview]="previewModeFlag"
    [mode]="mode"
  />
}

<ng-template #JSONImportContent let-modal>
  <div class="overflow-auto">
    <form [formGroup]="importForm">
      <div class="modal-content">

        <div class="modal-body">
          <input type="file" accept=".json,application/json" (change)="onFileImport($event)" />
          @if(uploadedFile?.length > 0) {
          <span>{{uploadedFile?.[0]?.name}} <a (click)="deleteUploadedFile()" title="Delete"><i class="fas fa-trash"></i></a></span>
          }
        </div>
        <div class="modal-footer">
          <div class="float-right">
            <input
              type="submit"
              (click)="onImportClick()"
              value="Import"
              class="btn btn-primary"
            />
            <input
              type="button"
              (click)="this.modalQuestionImportResponse.close()"
              class="btn cancelBtn m-2"
              data-dismiss="modal"
              value="Cancel"
            />
          </div>
          <br />
        </div>
      </div>
    </form>
  </div>
</ng-template>